export default __webpack_public_path__ + "static/3-2fb89b281676652c30c2888c403e6f3c.jpg";